module.exports = "<grid options=\"$ctrl.gridOptions\" ng-if=\"$ctrl.gridOptions\"></grid>"